import React from 'react';
import { Route, Switch } from 'react-router-dom';

import CreatePermissionSet from './CreatePermissionSet';
import EditPermissionSet from './EditPermissionSet';
import ListPermissionSets from './ListPermissionSets';

const PermissionSets = (props) => {
  return (
    <Switch>
      <Route exact path="/o/permission-sets" component={ListPermissionSets} />
      <Route path="/o/permission-sets/new" component={CreatePermissionSet} />
      <Route path="/o/permission-sets/edit/:id" component={EditPermissionSet} />
    </Switch>
  );
};

export default PermissionSets;
